interface Props {
  size?: 'sm' | 'md';
  className?: string;
}

export default function Spinner({ size = 'sm', className = '' }: Props) {
  const px = size === 'sm' ? 16 : 24;
  return (
    <svg
      className={`animate-spin ${className}`}
      width={px} height={px} viewBox="0 0 24 24"
      fill="none" xmlns="http://www.w3.org/2000/svg"
      role="status" aria-label="Loading">
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.25" strokeWidth="4" />
      <path d="M4 12a8 8 0 018-8" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}
